import { render } from "./CustomDomainPro.vue?vue&type=template&id=1008bc4b"
import script from "./CustomDomainPro.vue?vue&type=script&lang=js"
export * from "./CustomDomainPro.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__